module.exports = __webpack_public_path__ + "img/pdf.7033a675.png";